import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { A11Y_ROLES } from '@/utils/a11y-attrs';
import { RootState } from '@/redux/store';
import { SystemState, VehicleScheduleStateEnum } from '@/redux/type';
import { VehicleOwnerUseCase } from '@/fetch/bussiness/roadtest/types';
import { isTaskInProgress } from './utils';

export interface RoadTestEntryProps {
  vehicleName: string;
  onClick: () => void;
}

export const ROAD_TEST_ENTRY_TEST_ID = 'road-test-entry';

/**
 * 路测评价按钮
 */
const RoadTestEntry: React.FC<RoadTestEntryProps> = ({ onClick }) => {
  // 车辆的归属生命周期（用于判断车辆是否处于生产阶段）
  const ownerUseCase = useSelector(
    (state: RootState) =>
      state.singleVehiclePageInfo.vehicleBasicInfoNew?.ownerUseCase
  );
  // 车辆的路测任务状态
  const roadTaskExist = useSelector(
    (state: RootState) =>
      state.singleVehiclePageInfo.vehicleBasicInfoNew?.roadTaskExist
  );
  // 车辆的系统状态
  const systemState = useSelector(
    (state: RootState) =>
      state.singleVehiclePageInfo.vehicleRealTimeInfo?.systemState
  );
  // 车辆的调度状态
  const scheduleState = useSelector(
    (state: RootState) =>
      state.singleVehiclePageInfo.vehicleRealTimeInfo?.scheduleState
  );

  // 条件1: ownerUseCase 必须是 VehicleOwnerUseCase.PRODUCT
  const isProduct = ownerUseCase === VehicleOwnerUseCase.PRODUCT;
  // 条件2: systemState 不能是 OFFLINE
  const isNotOffline = systemState !== SystemState.OFFLINE;
  // 条件3: scheduleState 必须是 WAITING
  const isWaiting = scheduleState === VehicleScheduleStateEnum.WAITING;

  // 是否需要展示【路测评价】的按钮
  const visible = isProduct && isNotOffline && isWaiting;
  // 是否需要禁用【路测评价】的按钮
  const disabled = isTaskInProgress(roadTaskExist);

  /**
   * 点击【路测评价】按钮的回调
   */
  const handleClick = useCallback(() => {
    if (!disabled) {
      onClick();
    }
  }, [disabled, onClick]);

  if (!visible) {
    return null;
  }

  return (
    <div
      {...A11Y_ROLES.button(disabled ? '路测评价（任务进行中）' : '路测评价')}
      className={classNames('mini-item', 'road-test-entry', {
        'mini-item-disabled': disabled,
        'road-test-entry-disabled': disabled,
      })}
      data-testid={ROAD_TEST_ENTRY_TEST_ID}
      aria-disabled={disabled}
      onClick={handleClick}
    >
      <div
        className={classNames({
          'operate-jira': !disabled,
          'operate-jira-disabled': disabled,
        })}
      />
      <h3 className="operate_key">路测评价</h3>
    </div>
  );
};

export default React.memo(RoadTestEntry);
